import { render, staticRenderFns } from "./AppMyPageHeader.vue?vue&type=template&id=8dce1934"
import script from "./AppMyPageHeader.vue?vue&type=script&lang=js"
export * from "./AppMyPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports